import { PageContainer } from '@components/Layout/PageContainer';
import { useCurrentProject } from '@modules/projects/utils/useCurrentProject';
import { Stack } from '@mui/material';
import { useBudgetItemsQuery, useGetProjectBudgetQuery } from 'gql/index';
import { useIntl } from 'react-intl';
import { BudgetChart } from '../components/BudgetChart';
import { BudgetItemTable } from '../components/BudgetItemTable/BudgetItemTable';
import { BudgetItemTotals } from '../components/BudgetItemTable/components/BudgetItemTotals';
import { BudgetTableContextProvider } from '../components/BudgetItemTable/context/BudgetTableContextProvider';

export const ProjectBudgetPage: React.FC = () => {
  const { formatMessage } = useIntl();
  const { projectId } = useCurrentProject();
  const { data: budget } = useGetProjectBudgetQuery({ id: projectId }, { select: d => d.projectBudget });

  const { data: budgetItems } = useBudgetItemsQuery({ projectId }, { select: d => d.budgetItems });

  return (
    <PageContainer title={formatMessage({ id: 'Budget' })} maxWidth='xl'>
      <Stack gap={2}>
        {budget?.totalBudgetedAmount > 0 && (
          <BudgetChart />
        )}
        <BudgetTableContextProvider>
          <BudgetItemTotals budgetItems={budgetItems ?? []} />
          <BudgetItemTable />
        </BudgetTableContextProvider>
      </Stack>
    </PageContainer>
  );
};